import { ICON__minus, ICON__plus } from '@/assets/icons_fa';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { SEPARATOR__horizontal_dashed } from '@/pages/_base/separators/SEPARATOR__horizontal_dashed';
import { UTILS__generation } from '@/utils/UTILS__generation';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { DTO__generation_tool_grid2d_view } from '@shared/dto/generation/DTO__generation_tool_grid2d_view';
import { groupBy } from 'es-toolkit';
import React, { useRef, useState } from 'react';
import { HOOK__tools_is_selected } from '../../editor/HOOK__tools_is_selected';
import { G_LIST_ITEM__generation_tools_view } from './G_LIST_ITEM__generation_tools_view';

interface PROPS {
  tool: DTO__generation_tool;
}

export function G_LIST_ITEM__generation_tool_and_grid2d_views({ tool }: PROPS) {
  /*
   *
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   *
   */
  const ref__is_loading = useRef(false);

  const [is_hovered, set_is_hovered] = useState(false);

  const is_selected = HOOK__tools_is_selected(tool);
  const is_single_view = tool.grid2d_views_map.size() == 1;

  if (is_selected) tool = generation_current.tool;

  /*
   *
   */

  async function onClick() {
    if (g_general__ui_disabled) return;
    if (is_selected) return;
    if (ref__is_loading.current) return;

    ref__is_loading.current = true;

    await UTILS__generation.update_tool(tool);

    ref__is_loading.current = false;
  }

  /*
   *
   */

  /*
   *
   */
  function render_tool_views() {
    if (!is_selected) return null;
    if (is_single_view) return null;

    let views_by_groups = groupBy(tool.grid2d_views_map.values(), view => view.group);
    let groups_amount = Object.keys(views_by_groups).length;

    return (
      <div className="flex-col w-full bg-component">
        {Object.entries(views_by_groups).map(([group_name, items]) => {
          return (
            <React.Fragment key={`group_${group_name}`}>
              {render_tool_group_view(tool, group_name, items)}
              {groups_amount > 1 && <SEPARATOR__horizontal_dashed />}
            </React.Fragment>
          );
        })}
      </div>
    );
  }
  function render_tool_group_view(tool: DTO__generation_tool, group_name: string, tool_views: DTO__generation_tool_grid2d_view[]) {
    group_name = group_name.trim();

    let items = [...tool_views].sort(DTO__generation_tool_grid2d_view.sort_by_name).map(render_tool_group_view_item);

    return (
      <React.Fragment key={`tool_${tool._id}_${group_name}`}>
        {group_name.length > 0 && <SEPARATOR__horizontal_dashed />}
        {items}
      </React.Fragment>
    );
  }

  function render_tool_group_view_item(tool_view: DTO__generation_tool_grid2d_view) {
    return <G_LIST_ITEM__generation_tools_view key={tool_view.name} {...{ tool_view }} />;
  }

  function render_icon() {
    if (is_single_view) return <span>•</span>;

    return is_selected ? <ICON__minus className="size-2" /> : <ICON__plus className="size-2" />;
  }

  /*
   *
   */

  return (
    <>
      <div
        {...{ onClick }}
        className={`flex flex-col px-2 w-full
          cursor-pointer
      ${is_selected ? 'bg-component' : ''}
        `}
      >
        <div
          onMouseEnter={() => set_is_hovered(true)}
          onMouseLeave={() => set_is_hovered(false)}
          className={`
            flex items-center gap-1
            px-2 py-0.5 text-xs rounded-sm text-component-item-foreground
            
            ${(is_hovered && !is_selected) || (is_selected && is_single_view) ? 'bg-component-item-selected' : ''}
            `}
        >
          {render_icon()}
          {tool.name}
        </div>
        {render_tool_views()}
      </div>
    </>
  );
}
